import { instance } from '@/services/avik-api-gateway'
import { Event } from '@/types/event'
import { AxiosResponse } from 'axios'

export function createEvent(
  body: Partial<Event>
): Promise<AxiosResponse<Event>> {
  return instance.post(`/event`, body)
}
